export const cmsInstanceField = (): { cms?: string } => (process.env.CMS_INSTANCE ? { cms: process.env.CMS_INSTANCE } : {});

export const cmsInstanceQueryParam = (cmsInstance?: string): string => (cmsInstance ? `&cms=${encodeURIComponent(cmsInstance)}` : '');
